import script from "./BaseDeviceComponent.vue?vue&type=script&lang=js"
export * from "./BaseDeviceComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__